$(document).ready(function(){
    $('label.btn',$('#paymentForm')).tooltip();

    var toggleGroups = ['#toggler1'];

    toggleGroups.forEach(function (group_id){
        $('[data-toggle="collapse"]',$(group_id)).click(function (){
            var clickedTarget = $(this).attr('data-target');
            $(clickedTarget).collapse('show');
            $('[data-toggle="collapse"]',$(group_id)).each(function(){
                let target = $(this).attr('data-target');
                if(clickedTarget!==target){
                    $(target).collapse('hide');
                }
            })
        });
    });
});
